import { Alert } from '@mui/material';
import { REJECTION_MESSAGES } from '../constants/rejectionMessages';
import type { RejectionReason } from '../constants/rejectionMessages';

interface RetryMessageProps {
  reason: RejectionReason;
}

// Alerta compacta que muestra la instrucción de reintento según la razón de rechazo anterior
export function RetryMessage({ reason }: RetryMessageProps) {
  const message = REJECTION_MESSAGES[reason];

  if (!message.retryInstruction) {
    return null;
  }

  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      {message.retryInstruction}
    </Alert>
  );
}
